import { BrowserModule } from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import { AppComponent } from './app.component';
import {LoaderComponent} from './components/loader/loader.component';
import {LoaderService} from './components/loader/loader.service';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MDBBootstrapModulesPro, ToastModule} from 'ng-uikit-pro-standard';
import {AppRoutingModule} from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {SharedModule} from './modules/shared/shared.module';
import {ApplicationConfig} from './config/application.config';
import {ApiRoutes} from './config/api-routes';
import {LoggedInGuard} from './guards/logged-in.guard';
import {DashboardComponent} from './modules/dashboard/dashboard.component';
import {NavbarComponent} from './components/navbar/navbar.component';
import {BuildingsService} from './modules/shared/service/buildings.service';
import {NgSelectModule} from '@ng-select/ng-select';
import { CookieService } from 'ngx-cookie-service';
import {GlobalErrorHandler} from './config/global-error-handler';
import {LoggerService} from './service/logger.service';
import {Localization} from './modules/shared/enums/localization';
import {ChappsCommonAngularLibraryModule} from '@npm.chapps.com/chapps.common.angular.library';
import {environment} from '../environments/environment';
import {ILocalization} from '@npm.chapps.com/chapps.common.angular.library/lib/interface/ILocalization';
import { InterventionsService } from './modules/shared/service/interventions.service';
import { LicenseComponent } from './modules/license/license.component';
import { AgreeLicenseModalComponent } from './modules/license/agree-license-modal/agree-license-modal';
import { AccountAlreadyConfirmedComponent } from './modules/account/account-already-confirmed/account-already-confirmed.component';
import { AccountConfirmComponent } from './modules/account/account-confirm/account-confirm.component';
import { AccountErrorComponent } from './modules/account/account-error/account-error.component';
import { AccountCreatedComponent } from './modules/account/account-created/account-created.component';
import { ForbiddenPageComponent } from './components/forbidden-page/forbidden-page.component';
import { PermissionsGuard } from './guards/permissions.guard';
import { PermissionsService } from './service/permissions.service';
import { AccountsService } from './modules/accounts/accounts.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppContextRedirectConfig } from './config/app-context-redirect-config';
import {AngularSvgIconModule} from 'angular-svg-icon';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.apiUrl + 'api/translations/', '.json');
}


@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({loader: {provide: TranslateLoader, useFactory: (createTranslateLoader), deps: [HttpClient]}}),
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HttpClientModule,
        ToastModule.forRoot(),
        MDBBootstrapModulesPro.forRoot(),
        SharedModule.forRoot(),
        NgSelectModule,
        ChappsCommonAngularLibraryModule.forRoot(
            Localization as ILocalization,
            ApplicationConfig.PRIMARY_COLOR,
            ApplicationConfig.SECONDARY_COLOR,
            AppContextRedirectConfig.CONFIG
        ),
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
        AngularSvgIconModule,
    ],
  declarations: [
    AppComponent,
    LoaderComponent,
    DashboardComponent,
    NavbarComponent,
    LicenseComponent,
    AgreeLicenseModalComponent,
    AccountAlreadyConfirmedComponent,
    AccountConfirmComponent,
    AccountErrorComponent,
    AccountCreatedComponent,
    ForbiddenPageComponent,
  ],
  providers: [
    LoaderService,
    LoggerService,
    ApplicationConfig,
    ApiRoutes,
    LoggedInGuard,
    BuildingsService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler},
    CookieService,
    InterventionsService,
    PermissionsService,
    PermissionsGuard,
    AccountsService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

